module.exports = __webpack_public_path__ + "static/img/footer-qrcode.94d4ca4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/footer-qrcode.jpg
// module id = 641
// module chunks = 36